<template>
  <div class="annotationpopupBack" @click.self.prevent="goBack()">
    <span class="close" @click="goBack()">&times;</span>
    <div class="detailedUI_div">
      <changeTextureCard></changeTextureCard>
    </div>
  </div>
</template>

<script>
import changeTextureCard from "../components/changetexture";

export default {
  data: function () {
    return {};
  },
  components: {
    changeTextureCard,
  },

  methods: {
    hasHistory() {
      return window.history.length > 2;
    },
    goBack() {
      if (this.hasHistory()) {
        this.$router.go(-1);
      } else {
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.annotationpopupBack {
  position: fixed;
  width: 100%;
  height: 100%;
  display: block;
  overflow-y: hidden;
  top: 0;
  left: 0;
  background-color: rgba(#c3c3c3, 0.3);
  z-index: 90000;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  color: #f1f1f1;
  font-size: 30px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.detailedUI_div {
  position: absolute;

  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-family: "Nunito Sans";
  background-color: transparent;
}
</style>
